export enum ClientMotivation {
	PROACTIVE = "PROACTIVE",
	AMBIVALENT = "AMBIVALENT",
	RESISTANT = "RESISTANT",
}
